/* Kaporal Premium — swatchs de couleur : 6 visibles, puis un « +N » qui déplie le reste. */
(function () {
	'use strict';

	var LIMIT = 6;
	var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
	var TXT = isFr
		? { more: 'Afficher %n couleurs de plus', less: 'Réduire les couleurs' }
		: { more: 'Show %n more colours', less: 'Show fewer colours' };
	var SWATCH = '.color-swatch, .variant-swatch';

	function entries(group) {
		return Array.prototype.filter.call(group.children, function (el) {
			return el.tagName !== 'INPUT' && !el.classList.contains('kp-swatch-more');
		});
	}

	function prepare(group) {
		if (group.hasAttribute('data-kp')) return;
		if (!group.querySelector(SWATCH)) return;
		group.setAttribute('data-kp', '1');

		var list = entries(group);
		if (list.length <= LIMIT) return;

		/* si la couleur choisie est au-delà de la 6e, tout reste déplié pour garder le contexte */
		var selectedBeyond = list.some(function (el, index) {
			var input = el.previousElementSibling;
			return index >= LIMIT && input && input.tagName === 'INPUT' && input.checked;
		});

		var hidden = list.length - LIMIT;
		list.forEach(function (el, index) {
			if (index < LIMIT) return;
			var input = el.previousElementSibling;
			el.classList.add('kp-swatch-extra');
			if (input && input.tagName === 'INPUT') input.classList.add('kp-swatch-extra');
		});

		var button = document.createElement('button');
		button.type = 'button';
		button.className = 'kp-swatch-more';
		button.setAttribute('data-count', String(hidden));
		group.classList.add('kp-swatches--collapsible');
		if (selectedBeyond) {
			group.classList.add('kp-swatches--open');
			button.setAttribute('aria-expanded', 'true');
			button.setAttribute('aria-label', TXT.less);
			button.textContent = '−';
		} else {
			button.setAttribute('aria-expanded', 'false');
			button.setAttribute('aria-label', TXT.more.replace('%n', hidden));
			button.textContent = '+' + hidden;
		}
		group.appendChild(button);
	}

	function scan() {
		var groups = document.querySelectorAll('.product-form__controls-group');
		for (var i = 0; i < groups.length; i += 1) prepare(groups[i]);
	}

	document.addEventListener(
		'click',
		function (event) {
			var button = event.target.closest ? event.target.closest('.kp-swatch-more') : null;
			if (!button) return;
			event.preventDefault();
			event.stopPropagation();
			var group = button.parentNode;
			var open = group.classList.toggle('kp-swatches--open');
			var count = button.getAttribute('data-count');
			button.setAttribute('aria-expanded', open ? 'true' : 'false');
			button.setAttribute('aria-label', open ? TXT.less : TXT.more.replace('%n', count));
			button.textContent = open ? '−' : '+' + count;
		},
		true
	);

	var queued = false;
	function schedule() {
		if (queued) return;
		queued = true;
		window.requestAnimationFrame(function () {
			queued = false;
			scan();
		});
	}

	function start() {
		scan();
		new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
	document.addEventListener('shopify:section:load', scan);
})();
